module.exports = __webpack_public_path__ + "img/225-Veka Spectral 6012-Vert Noir.png";